<script>
    /**
     * Filename: 传送门（vue3阉割版）
	 * 
     * @param {string} to 标签id
	 * 
     * Copyright (c) 2022 Your Company
     */
	export default {
		name: 'cl-teleport',
		props: {
			/* 移动至哪个标签内，最好使用id */
			to: {
				type: String,
				required: true
			}
		},

		mounted() {
			document.querySelector(this.to).appendChild(this.$el)
		},

		destroyed() {
			const dom = document.querySelector(this.to)
			dom && dom.removeChild(this.$el)
		},

		render() {
			return this.$scopedSlots.default()
		}
	}
</script>